export default __webpack_public_path__ + "static/media/buiss.8cbee1ca.svg";